module.exports = __webpack_public_path__ + "static/media/crowdFunding.35d5297f.svg";